import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const UnibaBannerSkeleton = () => {
    return (
        <div id="banner-uniba">
            <div style={{
                visibility: 'visible',
                height: 'auto',
                overflow: 'hidden',
            }}>
                <div className="container hy">
                    <div className="row hy-row m-0">
                        <div className="col-md-9 hy-col9">
                            <div className="hy-image-container">
                                <Skeleton height={80} width={400} />
                            </div>
                        </div>
                        <div className="col-md-3 hy-col3">
                            <Skeleton height={40} width={100} borderRadius={8} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnibaBannerSkeleton;
